import { createClientConfig } from "@repo/design-system/lib/client-registry";
import {
  filterTypes as by,
  type Filter,
} from "@repo/design-system/types/filter";
import Filterbar from "~/components/job-board/filterbar/filterbar-eon";
import { Joblist } from "~/components/job-board/joblist-eon";
import { UnifiedJobPageTemplate } from "~/components/job-page/jobpagetemplate/unified-jobpage-template";
import { defaultTemplate } from "./default";
import { intGraduateTemplate } from "./int-graduate";

export const eon = createClientConfig({
  components: {
    JobpageTemplate: UnifiedJobPageTemplate,
    Filterbar,
    Joblist,
  },
  ui: {
    filterGroups: [by.EMPLOYMENT_TYPE, by.CONTRACT] as Filter[],
    searchSummaryEmpty: null,
    recruiterImageBasePath: "images/recruiter",
    // Whether the "Quick application" (direct apply) button is shown
    showQuickApply: true as boolean,
    // External privacy policy linked from the job-ad privacy notice.
    // null → the app's own /privacy-policy-recruiting page.
    privacyPolicyHref: null as string | null,
  },
  // Order matters: more specific templates first, defaultTemplate last as fallback
  subtemplates: [intGraduateTemplate, defaultTemplate],
});
